// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__nnZ84","row":"styles_row__pb5yN","mb":"styles_mb__ElMT_","description":"styles_description__PqOXE","text":"styles_text__LVqMO"};